import { render, staticRenderFns } from "./TournamentDetailsFrameCard.vue?vue&type=template&id=276a2fec&scoped=true&"
import script from "./TournamentDetailsFrameCard.vue?vue&type=script&lang=js&"
export * from "./TournamentDetailsFrameCard.vue?vue&type=script&lang=js&"
import style0 from "./TournamentDetailsFrameCard.vue?vue&type=style&index=0&id=276a2fec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276a2fec",
  null
  
)

export default component.exports